<template>
    <div v-if="user" class="container account">
      <div v-if="user.date_joined && user.type == 'user'" style="max-width:600px" class="mx-auto white--text synThickFont">
        <!-- ################################### -->
        <!-- TODO: FIX NAVBAR LOADING -->
        <!-- ################################### -->
        <div class="text-center"><v-icon color="white">mdi-account</v-icon></div>
        <div class="text-center mb-5"><h2 >Account</h2></div>

        <v-simple-table   class="mb-5 asTable white--text">
            <!-- <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Calories</th>
              </tr>
            </thead> -->
            <tbody>
              <!-- <tr v-for="item in desserts" :key="item.name">
                <td>{{ item.name }}</td>
                <td>{{ item.calories }}</td>
              </tr> -->
              <tr>
                <td class="mb-2 artistSettingsTD" >
                    <v-row :class="{ hideBox: !hideUpdateDisplayname }">
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Name</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                          <v-row no-gutters>
                            <v-col cols=11>
                              <div class="text-left synThinFont">{{user.displayname}}</div>
                            </v-col>
                            <v-col cols=1>
                              <v-icon @click="editDisplayName()" color="warning">mdi-pencil</v-icon>
                            </v-col>
                          </v-row>
                            
                        </v-col>
                    </v-row>
                    <v-row :class="{ hideBox: hideUpdateDisplayname }">
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Update Name</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                          
                            <v-form dark v-model="dnvalid" color="white" ref="updateDisplaynameForm" v-on:submit.prevent="updateDisplayname" class="px-3 primary--text synThinFont">
                              <v-text-field 
                                  label="Full Name or Artist Name" 
                                  v-model="displayname"
                                  :rules="displaynameRules"
                              ></v-text-field>
                              <div class="text-center">

                                  <v-btn
                                      color="syn_green"
                                      depressed
                                      class="white--text  synThickFont mt-3 ml-3 linkHover"
                                      :loading="dnloading"
                                      type="submit"
                                      @click="hideUpdateDisplayname = true"
                                  >
                                      Update
                                  </v-btn>
                              </div>

                              <div class='red--text '><span>{{feedback}}</span></div>                    

                              
                          </v-form>
                        </v-col>
                    </v-row>
                </td>
                <!-- <td class="artistSettingsTD"></td> -->
                <!-- <td class="text-right"><v-btn  color="warning" dark text><v-icon>mdi-pencil</v-icon></v-btn></td> -->
              </tr>
              <tr>
                <td class="mb-2 artistSettingsTD" >
                    <v-row>
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Username</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                            <div class="text-left synThinFont">{{user.username}}</div>
                        </v-col>
                    </v-row>
                </td>
                <!-- <td></td> -->
              </tr>
              <tr>
                <td class="mb-2 artistSettingsTD" >
                    <v-row>
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Email</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                            <div class="text-left synThinFont">{{user.email}}</div>
                        </v-col>
                    </v-row>
                </td>
                <!-- <td></td> -->
              </tr>
              <tr>
                <td class="mb-2 artistSettingsTD" >
                    <v-row>
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Date Joined</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                            <div class="text-left synThinFont"><span class="synThinFont" v-if="user.date_joined">{{user.date_joined}}</span></div>
                        </v-col>
                    </v-row>
                </td>
                <!-- <td></td> -->
              </tr>
              <tr>
                <td class="artistSettingsTD">
                    
                    <v-row :class="{ hideBox: !hideUpdatePassword }">
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left synThickFont">Password</div> 
                        </v-col>
                        <v-col cols=12 sm=6>
                            <div class="text-left">
                                <v-btn text class="linkHover px-0" color="warning" @click="hideUpdatePassword = false">Click to update password</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                    <!-- UPDATE PASSWORD -->
                    <v-row :class="{ hideBox: hideUpdatePassword }" class="mb-3" style="background-color:transparent">
                        <v-col cols=12 sm=6 style="margin-top:auto;margin-bottom:auto">
                            <div class="text-left white--text mt-2 synThickFont">Updating Password</div>
                        </v-col>
                        <v-col cols=12 sm=6>
                            <div class="text-left">
                                <v-form dark v-model="valid" ref="updatePasswordForm" v-on:submit.prevent="updatePassword" class="px-3 primary--text synThinFont">
                                    <v-text-field 
                                        label="Password" 
                                        :type="'password'" 
                                        v-model=password
                                        :rules="passwordRules"
                                        color="white"
                                    ></v-text-field>
                                    <v-text-field 
                                        label="Confirm Password" 
                                        :type="'password'" 
                                        v-model=confirmPassword
                                        :rules="confirmPasswordRules"
                                    ></v-text-field>
                                    <div class="text-center">

                                        <v-btn
                                            color="syn_green"
                                            depressed
                                            class="white--text  synThickFont mt-3 ml-3 linkHover"
                                            :loading="loading"
                                            type="submit"
                                            @click="hideUpdatePassword = true"
                                        >
                                            Update
                                        </v-btn>
                                    </div>

                                    <div class='red--text '><span>{{feedback}}</span></div>                    

                                    
                                </v-form>
                            </div>
                        </v-col>
                    
                        
                        
                    </v-row> 
                    
                </td>
            </tr>
              <!-- <tr>
                <td class="mb-2">Country</td>
                <td>
                  <span v-if="user.country" class="synThinFont">{{user.country}}</span>
                  <span v-else class="synThinFont">N/A</span>
                </td>
                <td class="text-right"><v-btn  color="warning" dark text><v-icon>mdi-pencil</v-icon></v-btn></td>
              </tr>
              <tr>
                <td class="mb-2">Bio</td>
                <td>
                  <span v-if="user.bio" class="synThinFont">{{user.bio}}</span>
                  <span v-else class="synThinFont">N/A</span>
                </td>
                <td class="text-right"><v-btn  color="warning" dark text><v-icon>mdi-pencil</v-icon></v-btn></td>
              </tr> -->
            </tbody>
        </v-simple-table>
        <!-- <v-simple-table  class="mb-5">
            <tbody>
              <tr>
                <td class="mb-2">Overall Submissions</td>
                <td><span class="synThinFont"></span></td>
                <td></td>
              </tr>
              <tr>
                <td class="mb-2">Overall Songs Uploaded</td>
                <td><span class="synThinFont"></span></td>
                <td></td>
              </tr>
              <tr>
                <td class="mb-2">Returned Submissions</td>
                <td><span class="synThinFont"></span></td>
                <td></td>
              </tr>
              <tr>
                <td class="mb-2">Expired Submissions</td>
                <td><span class="synThinFont"></span></td>
                <td></td>
              </tr>
              <tr>
                <td class="mb-2">Average Ratings</td>
                <td><span class="synThinFont"></span></td>
                <td></td>
              </tr>
            </tbody>
        </v-simple-table> -->
      
        <div class="text-center">
          <v-btn v-if="user" text  @click="logout" class='syn_blue_button white--text letterSpacing-med'>
              <span>sign out</span>
              <v-icon right>mdi-logout</v-icon>
          </v-btn>
        </div>
      </div>
      <v-snackbar
          v-model="snackbarFail"
          color= 'red'
          >
          {{ snackbarFailText }}
      </v-snackbar>
      <v-snackbar
          v-model="snackbarSuccess"
          color= 'green'
          >
          {{ snackbarSuccessText }}
      </v-snackbar>
      <Overlay :overlay="overlay" />
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
import Overlay from '@/components/layout/Overlay'
const db = fb.db


export default {
  name: 'Account',
  data() {
      return {
          user: null,
          overlay: true,
          hideUpdatePassword: true,
          hideUpdateDisplayname: true,
          snackbarFail: false,
          snackbarFailText: null,
          displayname: null,

          snackbarSuccess: false,
          snackbarSuccessText: null,
          valid: false,
          dnvalid: false,
          loading: false,
          dnloading: false,
          password: null,
          confirmPassword: null,
          feedback: null,
          passwordRules: [
              v => !!v || 'Password is required',
          ],
          confirmPasswordRules: [
              v => (v === this.password) || 'Passwords must match'
          ],
          displaynameRules: [
              v => !!v || 'Name is required',
              v => (v && v.length >= 3) || 'Username must be greater than 3 characters',
              v => (v && v.length <= 30) || 'Username must be less than 30 characters'
          ]
      }
  },
  components:{
    Overlay
  },
  methods: {
    editDisplayName(){
      this.hideUpdateDisplayname = false
    },
    updateDisplayname(){
      this.dnloading=true;
      const that = this
      if(this.dnvalid){
        db.collection("users").doc(this.user.id).update({
          displayname: this.displayname
        }).then(() => {
            this.dnloading=false
            this.snackbarSuccessText = 'You have successfully updated your display name.',
            this.snackbarSuccess = true
            this.hideUpdateDisplayname = true
            this.user.displayname = this.displayname
        }).catch(function(error) {
            // An error happened.
            console.log(error);
            that.snackbarFailText = error.message
            that.snackbarFail = true
            that.displayname = null
            // this.feedback = error.message
            that.dnloading=false
        });
      }
    },
    logout(){
      firebase.auth().signOut().then(() => {
        // this.$router.push({name:'Login'})
        location.href = "/";
      })
    },
    updatePassword(){
      this.loading=true
      
      if (this.valid){
          var user = firebase.auth().currentUser;
          const that = this
          user.updatePassword(this.password).then(function() {
              // Update successful.
              // console.log('password successfully updated');
              

          }).then(() => {
              this.loading=false
              this.snackbarSuccessText = 'You have successfully updated your password.',
              this.snackbarSuccess = true
              // console.log("Hello");
              // setTimeout(() => {  console.log("World!"); }, 2000);
              
          }).catch(function(error) {
              // An error happened.
              console.log(error);
              that.snackbarFailText = error.message
              that.snackbarFail = true
              that.password = null
              that.confirmPassword = null
              // this.feedback = error.message
              that.loading=false
          });
          
      } else {
          this.snackbarFailText = 'Something went wrong. Please try again & make sure your passwords match.';
          this.snackbarFail = true
          this.password = null
          this.confirmPassword = null
          this.loading=false
      }
      
  },
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        
        let ref = db.collection('users')


        // get current user
        ref.where('user_id','==',firebase.auth().currentUser.uid).get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            this.user = doc.data(),
            this.user.id = doc.id
            this.user.email = user.email
          })
        }).then(()=> {
          this.user.date_joined = firebase.auth().currentUser.metadata.creationTime
          // console.log(this.user.date_joined);
        }).then(()=>{
          this.overlay=false
        })

        
              
      } else {
        this.user = null
      }
    })
  },
}
</script>
<style >
.asTable{
    border: rgba(255,255,255,0.3) 1px solid;
    /* background-color:rgba(5,25,43,0.4); */
    border-radius: 5px;
    background-color: rgba(5,25,43,0.8) !important; 
}
.artistSettingsTD{
    border-bottom:rgba(255,255,255,0.3) 1px solid !important;
}
.account tr:hover{
    background-color: rgba(5,25,43,1) !important;
}
.hideBox{
    display: none;
}
.account input{
  color:white !important;
}
</style>